/**
 * Utility-Funktionen für Feld-Verarbeitung
 */

/**
 * Generische HTML-Sanitization-Funktion
 * @param {string} html - Das zu sanitizierende HTML
 * @param {Object} options - Optionen für die Sanitization
 * @returns {string} - Das sanitizierte HTML
 */
export const sanitizeHtml = (html, options = {}) => {
  if (!html) return ''
  
  
  const allowedTags = ['a']
  
  let sanitized = html
  
  
  const tagRegex = /<(\/?)([a-zA-Z][a-zA-Z0-9]*)([^>]*)>/g
  
  sanitized = sanitized.replace(tagRegex, (match, slash, tagName, attributes) => {
    
    if (!allowedTags.includes(tagName.toLowerCase())) {
      return '' 
    }
    
    
    if (attributes) {
      const hrefRegex = /href=["']([^"']*)["']/i
      const hrefMatch = attributes.match(hrefRegex)
      
      if (hrefMatch) {
        let href = hrefMatch[1]
        
        if (href.startsWith('http://')) {
          href = href.replace('http://', 'https://')
        }
        
        if (!href.startsWith('https://') && !href.startsWith('http://')) {
          href = 'https://' + href
        }
        return `<${slash}${tagName} href="${href}" target="_blank" rel="noopener noreferrer">`
      }
    }
    
    
    return `<${slash}${tagName} target="_blank" rel="noopener noreferrer">`
  })
  
  return sanitized
} 